/**
 * Form tag name
 */
export const FORM_TAG = 'FORM';
